import { Box, MenuItem, Select, TextField, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const StyledSelect = styled(Select)`
  border-radius: 8px 0 0 8px;
`;

const type = [
  { label: 'School', value: 'school' },
  { label: 'College', value: 'college' }
];

export default function CustomCollegeInput({ onChange, error }) {
  const [selectionType, setSelectionType] = useState('school');
  // Name
  const [name, setName] = useState('');

  useEffect(() => {
    onChange({
      view: 'custom',
      type: selectionType,
      name
    });
  }, [name, selectionType]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex' }}>
        <StyledSelect value={selectionType} onChange={(e) => setSelectionType(e.target.value)}>
          {type.map((t, index) => (
            <MenuItem key={index} value={t.value}>
              {t.label}
            </MenuItem>
          ))}
        </StyledSelect>
        <TextField
          sx={{
            '.MuiOutlinedInput-root': {
              borderLeft: 'none',
              borderRadius: '0 8px 8px 0'
            }
          }}
          error={error || false}
          placeholder="Ex: New Era School"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Box>
    </Box>
  );
}

CustomCollegeInput.propTypes = {
  onChange: PropTypes.func,
  error: PropTypes.any
};
